import { logger } from '@dealerportal/core';
import type { NavigationPlugin } from '../types';

export const analyticsPlugin: NavigationPlugin = {
  name: 'analytics',
  handler({ pathname, clientName, universalRetailerId }) {
    window.analytics?.page?.(
      { retailer: { name: clientName, universalRetailerId } },
      window.analytics?._defaultContext
    );
    logger.withMetadata({ pathname }).info('Tracked page view');
  },
};
